import { lazy } from 'react';

const RELOAD_FLAG = 'celebrations.chunkReloadedAt';

/**
 * React.lazy for modules that only provide named exports. If a chunk fails to load
 * (typically a stale tab after a new deploy), reload once to pick up the new build.
 */
export function lazyNamed(loader, exportName) {
  return lazy(() => loader().then(
    module => ({ default: module[exportName] }),
    error => {
      const lastReload = Number(window.sessionStorage.getItem(RELOAD_FLAG)) || 0;
      if (Date.now() - lastReload > 60_000) {
        window.sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
        window.location.reload();
        return new Promise(() => {});
      }
      throw error;
    }
  ));
}
